export default __webpack_public_path__ + "static/media/cal.830692e4.jpg";